import { render, staticRenderFns } from "./SplSpinner.vue?vue&type=template&id=defb807e&functional=true"
import script from "./SplSpinner.vue?vue&type=script&lang=js"
export * from "./SplSpinner.vue?vue&type=script&lang=js"
import style0 from "./SplSpinner.vue?vue&type=style&index=0&id=defb807e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports